import { combineReducers } from "redux";
import authReducer from "./authReducer";
import dashboardReducer from "./dashboardReducer";
import { LOGOUT } from "../utils/constants";
import dateRangeReducer from "./dateRangeReducer";
import studyReducer from "./studyReducer";
import sessionReducer from "./sessionReducer";
import sessionCodeReducer from "./sessionCodeReducer";
import selectedSurveyCategoryReducer from "./selectedSurveyCateogoryReducer";
// const rootReducer = combineReducers({
//   auth: authReducer,
//   dashboard: dashboardReducer
// });

const appReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  dateRange: dateRangeReducer,
  study: studyReducer,
  session: sessionReducer,
  sessionCode: sessionCodeReducer,
  selectedSurveyCategory: selectedSurveyCategoryReducer,
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
